import { lazyLoad } from 'utils/loadable';

export const WelfarePage = lazyLoad(
  () => import('./index'),
  module => module.WelfarePage,
);
